import BaseService from "./BaseService";

export default class RateService extends BaseService {
  static endPoint = "rate";
}
